module.exports = __webpack_public_path__ + "img/right.28f40d1d.png";